<section class="cmn-innerpage-wrapper">
  <div class="flex-wrapper">
    <div class="leftWrapper">
      <ul>
        <li *ngFor="let list of parentList; let index = index">
          <div
            class="listWrapper"
            (click)="handleParent(index)"
            [class.selected]="index == selectedParent"
          >
            <div class="imageWrapper">
              <img src="../../../assets/images/placeHolderImage.jpg" />
            </div>

            <div>
              <h6>John Luke</h6>
              <p>2 Child Profiles</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="rightWrapper">
      <div class="profileWrapper">
        <div class="profileImage">
          <img src="../../../assets/images/placeHolderImage.jpg" alt="" />
        </div>
        <div class="profileData">
          <h5>John Luke</h5>
          <h6>Parent</h6>
          <div class="contactWrapper">
            <div>
              <img src="../../../assets/images/icons/mail.svg" />
              <p>johnluke&#64;gmail.com</p>
            </div>
            <div>
              <img src="../../../assets/images/icons/phone.svg" />
              <p>+91 322342123</p>
            </div>
          </div>
        </div>
      </div>
      <div class="tableWrapper">
        <div class="tableHead"><h3>Child Profile</h3></div>
        <div class="tableContent">
          <table>
            <thead>
              <tr>
                <th>Avatar</th>
                <th>Name</th>
                <th>Age</th>
                <th>Gender</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="childProfileImage">
                    <img
                      src="../../../assets/images/placeHolderImage.jpg"
                      alt=""
                    />
                  </div>
                </td>
                <td><div>George Luke</div></td>
                <td><div>03</div></td>
                <td><div>Male</div></td>
              </tr>
              <tr>
                <td>
                  <div class="childProfileImage">
                    <img
                      src="../../../assets/images/placeHolderImage.jpg"
                      alt=""
                    />
                  </div>
                </td>
                <td><div>George Luke</div></td>
                <td><div>03</div></td>
                <td><div>Male</div></td>
              </tr>
              <tr>
                <td>
                  <div class="childProfileImage">
                    <img
                      src="../../../assets/images/placeHolderImage.jpg"
                      alt=""
                    />
                  </div>
                </td>
                <td><div>George Luke</div></td>
                <td><div>03</div></td>
                <td><div>Male</div></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
